import { Box, CircularProgress } from "@mui/material";
export const LoadText = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress size={20} color="secondary" />
    </Box>
  );
};
